
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Message from '@/components/message.vue';
  import {defaultHeader} from "@/utils/config"
	import {
    getSearchDate,
		nextDay,
    lastmonth,
    nowtime
	} from "@/utils"
  import {
    activityHelpactivityHelpInfo,
    activityHelpactivityHelpSave,
    activityHelpactivityHelpLiveData
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      UploadImg,
      Message
    }
  })

  export default class ProductList extends Vue {
    private defaultHeader = defaultHeader
    private helproute = 'pageA/pages/liveRoom/detail?id='
    private helplink = ''
    private type = 0
    private radioType = 1
    private radioList = [
      {value:1,label:'助力活动信息'},
      {value:2,label:'助力活动数据'},
    ]
    private form:any = {
      Id:0,
      ActivityName:'',
      StartTime:'',
      EndTime:'',
      requirements:true,
      helppeople:false,
      RankingRequirement:'',
      HelpCount:'',
      AwardName:'',
      AwardValue:'',
      AwardImgUrl:'',
      Description:'',
      RelationType:1,
      RelationId:this.$route.query.liveId,
    }
    private finishShow = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private tablelist:any = []
    private tableloading = false
    private justwin = false
    private isadvance = false
    private isover = false

    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getinfo()
        this.helplink = this.helproute + this.$route.query.liveId
      }
    }


    private async getinfo(){
      try{
        let res = await activityHelpactivityHelpInfo({
          RelationType:1,
          RelationId:this.$route.query.liveId,
        })
        if(res.IsSuccess){
          let form = res.Result
          form.requirements = true
          form.helppeople = form.HelpCount > 0
          let now = new Date().getTime()
          let start = new Date(form.StartTime).getTime()
          let end = new Date(form.EndTime).getTime()
          if(now >= start && now < end){
            this.type = 1
          }else if(now >= end){
            this.type = 2
          }
          // console.log(this.type)
          // this.isover = new Date().getTime() < new Date(form.EndTime).getTime()
          this.form = form
        }
      }finally{
        //
      }
    }
    private async gettablelist(){
      this.tableloading = true
      try{
        let data:any = {
          LiveRoomId:this.$route.query.liveId,
          IsOnlyLookAwadMember:this.justwin,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        let res = await activityHelpactivityHelpLiveData(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            if(v.AuthState!=2){
              v.RoleGrade = 0
            }
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private inadvanceend(){
      this.isadvance = true
      // this.save()
    }
    private testsave(){
      let form = JSON.parse(JSON.stringify(this.form))
      let two = /^\d+(\.\d{1,2})?$/
      if(!form.ActivityName){
        this.$message.error('请输入活动名称')
        return false
      }
      if(!form.StartTime){
        this.$message.error('请选择开始时间')
        return false
      }
      if(!form.EndTime){
        this.$message.error('请选择结束时间')
        return false
      }
      if(new Date(form.StartTime).getTime() >= new Date(form.EndTime).getTime()){
        this.$message.error('结束时间不得早于开始时间')
        return false
      }
      if(!form.RankingRequirement){
        this.$message.error('请输入中奖要求')
        return false
      }
      if(form.RankingRequirement<1 || form.RankingRequirement>9999){
        this.$message.error('请输入1~9999的整数')
        return false
      }
      if(form.helppeople){
        if(!form.HelpCount){
          this.$message.error('请输入助力人数')
          return false
        }else if(form.HelpCount<1 || form.HelpCount>9999){
          this.$message.error('请输入1~9999的整数')
          return false
        }
      }
      if(!form.AwardName){
        this.$message.error('请输入奖品名称')
        return false
      }
      if(!form.AwardValue){
        this.$message.error('请输入奖品价值金额')
        return false
      }
      if(form.AwardValue<0.01||form.AwardValue>99999.99||!two.test(form.AwardValue)){
        // console.log(1)
        this.$message.error('请输入0.01~99999.99的数值')
        return false
      }
      if(!form.AwardImgUrl){
        this.$message.error('请上传奖品图')
        return false
      }
      // console.log(form.AwardValue,form.AwardValue<0.01||form.AwardValue>99999.99||!two.test(form.AwardValue))
      // return false
      return true
    }
    private async save(){
      if(!this.testsave()) return
      try{
        let form = JSON.parse(JSON.stringify(this.form))
        if(!form.helppeople){
          form.HelpCount = ''
        }
        if(this.isadvance){
          form.EndTime = nowtime()
        }
        form.RelationId = this.$route.query.liveId
        form.RelationType = 1
        // console.log(form.EndTime)
        // return 
        let res = await activityHelpactivityHelpSave({
          ActivityHelpInfo:form
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          // this.toback()
          if(this.type==0&&Number(this.$route.query.Id)==0){
            this.finishShow = true
            this.helplink = this.helproute + res.Result.ActivityHelpId
            // let query = this.$route.query
            // query.Id = String(res.Result.ActivityHelpId)
            // this.$router.push({
            //   query:query
            // })
          }else{
            this.toback()
          }
        }
      }finally{
        //
      }
    }
    private toback(){
      this.$router.go(-1)
    }
    private uploadSuc(list){
      this.form.AwardImgUrl = list[0]
    }
    private handleChange(e){
      if(e==1){
        this.getinfo()
      }else{
        this.justwin = false
        this.pageNo = 1
        this.gettablelist()
      }
    }
  }
